module.exports = __webpack_public_path__ + "img/default_avatar.eccd0f8d.png";